module.exports = __webpack_public_path__ + "media/assets/images/blog/post-21marzo1-25-f3131ddff852ee7ca0786afa1553d289.png";